import { useContext, useEffect } from 'react'
import Head from 'next/head'
import styles from '../../styles/index.module.css'
import { TopBanner } from '../../components/index/TopBanner'
import { How } from '../../components/index/How'
import { Features } from '../../components/index/Features'
import { ServiceSection } from '../../components/index/ServiceSection'
import Script from 'next/script'
import { LocationContext } from '../../context/LocationContext'
import { ServiceList } from '../../components/index/ServiceList'
import { sgGeoCode, usGeoCode } from '../../utils/constants'
import { HandleTinyUrl } from '../../components/index/HandleTinyUrl'
import { latestBlogs } from '../../utils/us-blogs-data'
import { BlogsList } from '../../components/blogs/BlogList'
import { localBusinessNode } from 'utils/local-business-schema'

export async function getStaticProps() {

  const latest = latestBlogs

  return {
      props: {
        latest,
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      //revalidate: 864000, // In seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const latestBlogs = props.latest
    const { countryCd } = useContext(LocationContext)

  return (
    <>
      <Head>
        <title>Hire A Local Professional And Find Service Deals in United States!</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and more"/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content={`Hire A Local Professional And Find Service Deals Near You!`}/>
        <meta property="og:description" content="Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and more" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/"/>
        <meta name="twitter:title" content={`Hire A Local Professional And Find Service Deals Near You!`}/> 
        <meta name="twitter:description" content="Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and more"/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","alternateName":"Strings sg","url":"https://www.stringssg.com/","logo":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png","sameAs":"https://www.facebook.com/StringsSG/"},${JSON.stringify(localBusinessNode)},{"@type":"VideoObject","@id":"https://www.stringssg.com/#video","name":"Home Video - StringsSG","description":"Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and more.","thumbnailUrl":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/index.jpg"],"uploadDate":"2022-10-03T08:00:00+08:00","duration":"PT0M9S","contentUrl":"https://www.stringssg.com/video/main-least.mp4","interactionStatistic":{"@type":"InteractionCounter","interactionType":{"@type":"WatchAction"},"userInteractionCount":5647018}},{"@type":"Website","@id":"https://www.stringssg.com/#website","url":"https://www.stringssg.com/","name":"StringsSG Singapore","publisher":{"@id":"https://www.stringssg.com/#organization"},"description":"Request for a Property Agent, Financial Advisor, Personal trainer, Handyman, Domestic helper, Aircon servicing, Food Caterer, Interior Designer and more.","inLanguage":"en-US","video":{"@id":"https://www.stringssg.com/#video"},"datePublished":"2025-01-06T07:30:46+00:00","dateModified":"2022-10-06T07:30:46+00:00"}]}`
          }}
        />
        <link rel="canonical" href="https://www.stringssg.com/us" />
      </Head>
      <div className={styles.main}>     
          <HandleTinyUrl/>     
          <TopBanner/>
          {countryCd &&
            <>
              <ServiceList/>
              <ServiceSection/>
            </>
          }
          <How/>
          <Features/>
          {/* <div className='max-w-5xl mx-auto'>
            <BlogsList blogs={latestBlogs}/>
          </div> */}
      </div>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
